import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { footballPlayerService } from "../../../../../commons";
import { FootballBasicStatistics } from "../../../../../commons/models/football/football-basic-statistics";

export interface IFootballPlayerStatisticsState {
  playerStatistics: FootballBasicStatistics;
  playerStatisticsStatus: StatusEnum;
}

export interface IFootballPlayerStatisticsOption {
  playerId: number;
  urlParams: {
    seasonId: number;
  };
}

const initialState: IFootballPlayerStatisticsState = {
  playerStatistics: new FootballBasicStatistics(),
  playerStatisticsStatus: StatusEnum.Idle,
};

export const fetchPlayerBasicStatistics = createAsyncThunk(
  "players/fetchPlayerBasicStatistics",
  async (options: IFootballPlayerStatisticsOption, thunkAPI) => {
    try {
      const playerStatistics = await footballPlayerService.getStatistics(options.playerId, options.urlParams);
      return playerStatistics;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballPlayerStatisticsSlice = createSlice({
  name: "footballPlayerStatistics",
  initialState: initialState,
  reducers: {
    cleanUpPlayerStats(state) {
      state.playerStatistics = new FootballBasicStatistics();
      state.playerStatisticsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPlayerBasicStatistics.pending, (state) => {
        state.playerStatisticsStatus = StatusEnum.Loading;
      })
      .addCase(fetchPlayerBasicStatistics.fulfilled, (state, action: PayloadAction<FootballBasicStatistics>) => {
        state.playerStatisticsStatus = StatusEnum.Succeeded;
        state.playerStatistics = action.payload;
      })
      .addCase(fetchPlayerBasicStatistics.rejected, (state) => {
        state.playerStatisticsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpPlayerStats } = footballPlayerStatisticsSlice.actions;
export default footballPlayerStatisticsSlice.reducer;
